<div class="grid-wrapper section">
    @if (competitionTitle) {
        <ms-fixture-list-header [showFavoriteToggle]="isFavouriteVisible" [sport]="sport" [competitionTitle]="competitionTitle">
            @if (virtualCompetitionModel) {
                <ms-tournament-groups [model]="virtualCompetitionModel" />
            }
        </ms-fixture-list-header>
    }
    @if (sport && standingsData) {
        <ms-standings [sport]="sport" [standingsData]="standingsData" />
    }
</div>
